import { render } from "./RedirectPage.vue?vue&type=template&id=664596c6&scoped=true"
const script = {}

import "./RedirectPage.vue?vue&type=style&index=0&id=664596c6&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664596c6"]])

export default __exports__